import { Button } from "../ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "../ui/dialog";
import { MailPlus, Copy, Send } from "lucide-react";
import SafeHtml from "../SafeHtml";

const FollowupEmailDialog = ({ dialog, setDialog, onSend, copyToClipboard }) => (
  <Dialog open={dialog.open} onOpenChange={(open) => setDialog({ ...dialog, open })}>
    <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <MailPlus className="w-5 h-5 text-[#00341d]" />
          {dialog.email?.template_name || "Follow-up Email"}
        </DialogTitle>
        <DialogDescription>
          Review the email below, then click Send to deliver it to {dialog.quote?.customer_name}
        </DialogDescription>
      </DialogHeader>
      {dialog.email && (
        <div className="space-y-4 mt-4">
          <div>
            <div className="flex items-center justify-between mb-1">
              <label className="text-sm font-medium text-zinc-700">To:</label>
              <Button variant="ghost" size="sm" onClick={() => copyToClipboard(dialog.email.to, "Email")} className="h-6 px-2 text-xs"><Copy className="w-3 h-3 mr-1" /> Copy</Button>
            </div>
            <div className="bg-zinc-50 rounded px-3 py-2 text-sm">{dialog.email.to}</div>
          </div>
          <div>
            <div className="flex items-center justify-between mb-1">
              <label className="text-sm font-medium text-zinc-700">Subject:</label>
              <Button variant="ghost" size="sm" onClick={() => copyToClipboard(dialog.email.subject, "Subject")} className="h-6 px-2 text-xs"><Copy className="w-3 h-3 mr-1" /> Copy</Button>
            </div>
            <div className="bg-zinc-50 rounded px-3 py-2 text-sm font-medium">{dialog.email.subject}</div>
          </div>
          <div>
            <div className="flex items-center justify-between mb-1">
              <label className="text-sm font-medium text-zinc-700">Email Preview:</label>
              <Button variant="ghost" size="sm" onClick={() => copyToClipboard(dialog.email.html_body, "HTML")} className="h-6 px-2 text-xs"><Copy className="w-3 h-3 mr-1" /> Copy HTML</Button>
            </div>
            <SafeHtml className="border rounded-lg overflow-hidden bg-white" html={dialog.email.html_body} />
          </div>
          <div className="flex justify-end gap-3 pt-4 border-t border-zinc-200">
            <Button variant="outline" onClick={() => setDialog({ open: false, quote: null, email: null, sending: false })}>Cancel</Button>
            <Button onClick={onSend} disabled={dialog.sending} className="bg-[#00341d] hover:bg-[#002816] text-white" data-testid="send-followup-button">
              {dialog.sending ? (
                <span className="flex items-center gap-2"><span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />Sending...</span>
              ) : (<><Send className="w-4 h-4 mr-2" />Send Email</>)}
            </Button>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);

export default FollowupEmailDialog;
